import dayjs from 'dayjs';

import { ActivityTypes } from 'enums/types';

export const handleDefaultValues = ({ setValue, defaultValues }) => {
  const params = {
    type: defaultValues.type,
    dueAt: dayjs(defaultValues.dueAt).isValid() ? dayjs(defaultValues.dueAt).startOf('day') : null,
    dueTime: dayjs(defaultValues.dueAt).isValid() ? dayjs(defaultValues.dueAt).format('HH:mm') : null,
    estimatedKm: defaultValues.estimatedKm,
    collectEstimatedKm: defaultValues.collectEstimatedKm,
    estimatedVolume: defaultValues.estimatedVolume,
    partner: {
      label: defaultValues.partner?.name,
      id: defaultValues.partner?.id,
    },
    drivers: defaultValues.drivers?.map((driver) => ({
      label: driver.name,
      id: driver.id,
    })) ?? [{ }],
    vehicle: {
      label: defaultValues.vehicle?.licensePlate,
      id: defaultValues.vehicle?.id,
    },
    transhipmentDrivers: defaultValues.transhipmentDrivers?.map((driver) => ({
      label: driver.name,
      id: driver.id,
    })) ?? [{ }],
    transhipmentVehicle: {
      label: defaultValues.transhipmentVehicle?.licensePlate,
      id: defaultValues.transhipmentVehicle?.id,
    },
    followupDrivers: defaultValues.destinationDrivers?.map((driver) => ({
      label: driver.name,
      id: driver.id,
    })) ?? [{ }],
    followupVehicle: {
      label: defaultValues.destinationVehicle?.licensePlate,
      id: defaultValues.destinationVehicle?.id,
    },
    dispatchSource: {
      label: defaultValues.dispatchSource?.name,
      id: defaultValues.dispatchSource?.id,
    },
    dispatchDestination: {
      label: defaultValues.dispatchDestination?.name,
      id: defaultValues.dispatchDestination?.id,
    },
    collectActivities: defaultValues.collectActivities?.map((activity) => ({
      label: `Carga da atividade ${activity.order}`,
      id: activity.id,
    })) ?? [{ }],
    boardingAt: dayjs(defaultValues.boardingAt).isValid() ? dayjs(defaultValues.boardingAt).startOf('day') : null,
    boardingTime: dayjs(defaultValues.boardingAt).isValid() ? dayjs(defaultValues.boardingAt).format('HH:mm') : null,
    collectAt: dayjs(defaultValues.collectAt).isValid() ? dayjs(defaultValues.collectAt).startOf('day') : null,
    collectTime: dayjs(defaultValues.collectAt).isValid() ? dayjs(defaultValues.collectAt).format('HH:mm') : null,
    estimatedFollowupKm: defaultValues.estimatedFollowupKm,
    sourceName: defaultValues.sourceName,
    destinationName: defaultValues.destinationName,
    operator: defaultValues.operator,
    consignee: defaultValues.consignee,
    modality: defaultValues?.modality && {
      value: defaultValues?.modality,
      label: defaultValues?.modality,
    },
    code: defaultValues.code,
  };
  if (defaultValues.type === ActivityTypes.Transhipment) {
    Object.entries(defaultValues.address || { }).forEach(([key, value]) => setValue(`address.${key}`, value));
    setValue('address.city', {
      label: defaultValues?.address?.city,
      name: defaultValues?.address?.city,
    });
    setValue('address.state', {
      label: defaultValues?.address?.state,
      name: defaultValues?.address?.state,
    });
  }
  Object.entries(params || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val, idx) => setValue(`${key}.${idx}`, val));
    }
    setValue(key, value);
  });
};
